import { User } from '../users';


export class Profile extends User {

}
